import { render } from "./compliance_notifications.html?vue&type=template&id=556072c2&scoped=true&external"
import script from "./compliance_notifications.js?vue&type=script&lang=js&external"
export * from "./compliance_notifications.js?vue&type=script&lang=js&external"

import "./ComplianceNotifications.vue?vue&type=style&index=0&id=556072c2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556072c2"]])

export default __exports__